<template>
  <div class="el-upload">
    <el-form>
      <draggable
        @start="start"
        @end="end"
        v-model="fileList"
        class="upload-draggable"
      >
        <!-- 拖拽元素 -->
        <div
          class="itemI"
          v-for="(item, index) in fileList"
          :key="item + index"
          @mouseenter="mouseenter($event, index)"
          @mouseleave="mouseleave"
        >
          <el-image
            class="image"
            :src="item.url"
            :preview-src-list="[item]"
            fit="cover"
          ></el-image>
          <div class="mark">
          <!-- <div class="mark" v-if="isMark && indexM == index"> -->
            <i
              @click="handlePictureCardPreview(item)"
              class="el-icon-zoom-in"
              style="
                color: white;
                font-size: 20px;
                margin-right: 10px;
                z-index: 9999;
              "
            ></i>
            <i
              @click="handleRemove(item, index)"
              class="el-icon-delete"
              style="color: white; font-size: 20px"
            ></i>
          </div>
        </div>
        <el-upload
          v-if="fileList.length < limit"
          :limit="limit"
          action=""
          accept="image/*"
          :before-upload="beforeAvatarUpload"
          :http-request="uploadFile"
          list-type="picture-card"
          :auto-upload="true"
          :file-list="fileList"
          :on-preview="handlePictureCardPreview"

          :show-file-list="false"
          multiple
          ref="upload"
        >
        <!--           :on-exceed="handleExceed" -->
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <!--        <img src="https://img-home.csdnimg.cn/images/20201124032511.png" width="146" height="146">-->
        </el-upload>
      </draggable>
      <!-- 上传按钮 -->
      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img width="100%" fit="contain" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </el-form>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  components: {
    draggable
  },
  props: {
    limit: {
      type: Number,
      default: 6
    },
    list: {
      type: Array,
      default: () => []
    },
    showAddIcon: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    list (val, vall) {
      console.log(val)
      this.fileList = val
    }
  },
  data () {
    return {
      imageUrl: '',
      dialogImageUrl: '',
      dialogVisible: false,
      isMark: false,
      indexM: null,
      fileList: []
    }
  },
  methods: {
    mouseenter (e, index) {
      this.indexM = index
      this.isMark = true
    },
    mouseleave () {
      this.isMark = false
    },
    start (e) {
    },
    end (e) {
      this.$emit('changeImage', this.fileList)
    },
    submitUpload () { this.$refs.upload.submit() },
    beforeAvatarUpload (file) {
      const isPIC = (file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isPIC) {
        this.$message.error('请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片')
      }
      if (!isLt2M) {
        this.$message.error('图片大小必须小于2M')
      }
      return isPIC && isLt2M
    },
    uploadFile (e) {
      const file = e.file
      // const size = file.size / 1024 / 1024 / 2
      // console.log(size)
      // if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
      //   this.$notify.warning({
      //     title: '警告',
      //     message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
      //   })
      //   return
      // } else if (size > 2) {
      //   this.$notify.warning({
      //     title: '警告',
      //     message: '图片大小必须小于2M'
      //   })
      //   return
      // } else {
      const params = new FormData()
      params.append('file', file) // 图片
      console.log(params)
      this.$api.uploadFiles(params).then(res => {
        if (res.code === 0) {
          this.$message.success('上传成功')
          this.imageUrl = this.ImgHttps + res.data.url
          const obj = {
            url: this.imageUrl,
            mainFlag: false
          }
          this.fileList.push(obj)
          this.$emit('changeImage', this.fileList)
        } else {
          this.$message.error('上传失败')
        }
      })
      // }
    },
    // 图片上传超过数量限制
    handleExceed (files, fileList) {
      this.$message.error('图片数量超出限制!')
      console.log(files, fileList)
    },
    // 删除图片
    handleRemove (file, index) {
      this.fileList.splice(index, 1)
    },
    // 预览图片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="scss">
.el-dialog .el-dialog__header {
  border-bottom: none;
}
.upload-draggable {
  display: flex;
  flex-wrap: wrap;
}
.itemI {
  width: 128px;
  height: 128px;
  margin: 0 7px 7px 0;
  border: 1px dashed #d9d9d9;
  position: relative;
  box-sizing: border-box;
  .image {
    position: absolute;
    left: 0;
    top: 0;
    width: 128px;
    height: 128px;
    z-index: 1;
  }
  .mark {
    position: absolute;
    left: 0;
    top: 0;
    width: 128px;
    height: 128px;
    line-height: 128px;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.5);
    text-align: center;
  }
}
// .item:hover {
//   opacity: 0.5;
// }
</style>
